import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, of } from 'rxjs';
import { CustomerApi, UsersApi } from '@api/index';
import { UserLoad, UserLoadCustomersFailure, UserLoadCustomersSuccess } from './user.actions';

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private customerApi: CustomerApi,
    private usersApi: UsersApi
  ) {}

  loadCustomers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserLoad),
      switchMap(({ userId }) => {
        const apiCall = userId ? this.usersApi.getUserCustomers(userId) : this.customerApi.getCustomers();

        return apiCall.pipe(
          map(customers => UserLoadCustomersSuccess({ customers })),
          catchError(error => of(UserLoadCustomersFailure({ error })))
        );
      })
    )
  );
}
